export const AI_TRAINING_PARAMETERS_TEMPLATE = JSON.stringify(
    {
        trainee_level: '',
        personal_bests: {},
        disciplines: [],
        primary_discipline: '',
        cycle_start_date: null,
        pool_schedule: [],
        competition_targets: {},
        coaching_notes: '',
    },
    null,
    2
);

export const parseAiTrainingParameters = (value) => {
    const trimmedValue = (value || '').trim();

    if (!trimmedValue) {
        return { isValid: true, isEmpty: true, isLegacy: false, normalizedValue: '' };
    }

    let parsed;
    try {
        parsed = JSON.parse(trimmedValue);
    } catch (error) {
        return {
            isValid: false,
            isEmpty: false,
            isLegacy: false,
            error: 'AI training parameters must be valid JSON.',
        };
    }

    if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') {
        return { isValid: false, isEmpty: false, isLegacy: false, error: 'AI training parameters must be a JSON object.' };
    }

    if (Object.keys(parsed).length === 0) {
        return { isValid: false, isEmpty: false, isLegacy: false, error: 'AI training parameters must be a non-empty JSON object.' };
    }

    return {
        isValid: true,
        isEmpty: false,
        isLegacy: false,
        normalizedValue: JSON.stringify(parsed, null, 2),
    };
};
